import { Alert, Box, List, ListItem } from '@razorpay/blade/components';
import React from 'react';
import { FBPAmountDetailsCard } from './FBPAmountDetailsCard';

export const FBPAllocateDeclareHeader = ({
  isAdmin,
  totalAllocated,
  yearlyDeclarationsInAmount,
}: {
  isAdmin: boolean;
  totalAllocated: number | string;
  yearlyDeclarationsInAmount: Record<string, string>;
}) => {
  const totalAssigned = Object.values(yearlyDeclarationsInAmount).reduce(
    (acc, value) => acc + Number(value),
    0,
  );
  const totalUnallocated = Number(totalAllocated) - totalAssigned;
  return isAdmin ? (
    <Alert
      title="How to allocate or declare FBP"
      color="information"
      isFullWidth
      isDismissible={false}
      description={
        <List variant="ordered" size="small">
          <ListItem>
            Select the FBP you want to allocate. Once allocated, the employee can declare it, or you
            can declare it on their behalf.
          </ListItem>
          <ListItem>
            You also have the option to override the employee's FBP and declared amount.
          </ListItem>
        </List>
      }
    />
  ) : (
    <Box display={'grid'} gridTemplateColumns={'1fr 1fr 1fr'} width={'80%'} gap={'spacing.7'}>
      <FBPAmountDetailsCard title="Total allocated amount" amount={totalAllocated} />
      <FBPAmountDetailsCard title="FBP allocation" amount={totalAssigned} />
      <FBPAmountDetailsCard title="Unallocated amount" amount={totalUnallocated} />
    </Box>
  );
};
